import { Center, Spinner } from "@chakra-ui/react";

const LoadingSpinner = () => {
    return (
        <Center minH="100vh">
            <Spinner size="xl" color="brand.700" />
        </Center>
    );
};

export default LoadingSpinner;
